import React, { useState, useEffect } from 'react'
import { GoogleApiWrapper, Map, Marker, InfoWindow } from 'google-maps-react'
import { GOOGLE_MAPS_KEY } from 'helpers'

export const ParkingLotsMap = ({ service, global }) => {
  const [fetching, setFetching] = useState(true)
  const [parkingLots, setParkingLots] = useState([])
  const [currentLocation, setCurrentLocation] = useState({
    lat: -22.904477711506654,
    lng: -47.05995455716901,
  })

  useEffect(() => {
    service
      .get('parkinglot.list', '?type=rotativo&withParkingInterval')
      .then(items => {
        setParkingLots(items)

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(({ coords }) => {
            setCurrentLocation({ lat: coords.latitude, lng: coords.longitude })
          })
        }
      })
      .catch(err => global.modal.alert(err.message))
      .finally(() => setFetching(false))
    // eslint-disable-next-line
  }, [])

  return fetching ? (
    <div className="kt-portlet__body kt-pb-0 position-relative">
      <div className="row">Carregando...</div>
    </div>
  ) : (
    <div className="kt-portlet">
      <div className="kt-portlet__head">
        <div className="kt-portlet__head-label">
          <span className="kt-portlet__head-icon">
            <i className="kt-font-brand fas fa-map-marked-alt" />
          </span>
          <h3 className="kt-portlet__head-title">Mapa Atual</h3>
        </div>
      </div>
      <div className="kt-portlet__body">
        <div className="map">
          {parkingLots.length === 0 ? (
            'Nenhuma vaga com geolocalização e tempo máximo de ocupação.'
          ) : (
            <>
              <ul className="map-legend">
                <li>1 Hora</li>
                <li>2 Horas</li>
                <li>5 Horas</li>
              </ul>
              <LocationMap currentLocation={currentLocation} parkingLots={parkingLots} />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

const LocationMap = GoogleApiWrapper({ apiKey: GOOGLE_MAPS_KEY })(
  ({ parkingLots, currentLocation, google }) => {
    const center = currentLocation || parkingLots[0]?.geoLocation

    const [showingInfoWindow, setShowingInfoWindow] = useState(false)
    const [activeMarker, setActiveMarker] = useState({})
    const [selectedInfo, setSelectedInfo] = useState('')

    const onMarkerClick = (props, marker) => {
      setSelectedInfo(props.info)
      setActiveMarker(marker)
      setShowingInfoWindow(true)
    }

    const onMapClicked = () => {
      if (showingInfoWindow) {
        setActiveMarker(null)
        setShowingInfoWindow(false)
      }
    }

    return (
      <Map
        google={google}
        zoom={16}
        initialCenter={center}
        center={center}
        onReady={(mapProps, map) => {
          map.setOptions({
            styles: [
              {
                featureType: 'poi.business',
                stylers: [{ visibility: 'off' }],
              },
              {
                featureType: 'transit',
                elementType: 'labels.icon',
                stylers: [{ visibility: 'off' }],
              },
            ],
          })
        }}
        onClick={onMapClicked}
      >
        {parkingLots.map(lot => {
          let color = '#388E3C'

          if (lot.maxParkingInterval > 60 && lot.maxParkingInterval <= 120) {
            color = '#048BA8'
          } else if (lot.maxParkingInterval > 120 && lot.maxParkingInterval <= 180) {
            color = '#F29E4C'
          } else if (lot.maxParkingInterval > 180 && lot.maxParkingInterval <= 300) {
            color = '#A4036F'
          }

          let icon = `<svg width="30" height="30" viewBox="0 0 497 497" xmlns="http://www.w3.org/2000/svg"><path d="M28.7 452V45c0-9 7.3-16.3 16.3-16.3h407c9 0 16.3 7.3 16.3 16.3v407c0 9-7.3 16.3-16.3 16.3H45c-9 0-16.3-7.3-16.3-16.3z" fill="${color}"/><path d="M153.6 110c0-9.2 8.3-17.4 21.3-17.4h87.3c55.1 0 98.5 26.5 98.5 97.7v2.6c0 71.2-44.7 98.5-102 98.5h-48.6v100.7c0 11.7-14.3 17.8-28.2 17.8-14.4 0-28.3-6-28.3-17.8V110zm56.5 32v105.1h48.6c28.2 0 45.6-16 45.6-49.9V192c0-33.9-17.4-50-45.6-50h-48.6z" fill="#fff"/></svg>`

          return (
            <Marker
              key={lot.id}
              onClick={onMarkerClick}
              position={lot.geoLocation}
              icon={{ url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(icon)}` }}
              info={{ name: lot.name }}
            />
          )
        })}

        <InfoWindow marker={activeMarker} visible={showingInfoWindow}>
          <div>
            <h1 className="map--marker">{selectedInfo.name}</h1>
          </div>
        </InfoWindow>
      </Map>
    )
  },
)
